import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {IConversation} from '../models/conversation.model';

/**
 * TRẠM ĐIỀU PHỐI TƯƠNG TÁC (Event Bus)
 * Giúp các Service lớn (ChatCore, ListService, FilterService) giao tiếp với nhau
 * mà KHÔNG cần inject trực tiếp lẫn nhau (Tránh Circular Dependency).
 */
@Injectable({providedIn: 'root'})
export class ConversationInteractionService {
  /** Phát đi tín hiệu khi một hội thoại được người dùng chọn từ danh sách */
  private _selectConversation$ = new Subject<{
    conversationId: string;
    pageId: string;
    channel: number;
    snapshot?: IConversation;
  }>();
  public selectConversation$ = this._selectConversation$.asObservable();

  /** Phát đi tín hiệu khi một hội thoại đã được nạp xong và đánh dấu "đã đọc" */
  private _conversationRead$ = new Subject<string>();
  public conversationRead$ = this._conversationRead$.asObservable();

  /** Phát đi tín hiệu yêu cầu danh sách hội thoại làm mới (Refresh) */
  private _refreshList$ = new Subject<void>();
  public refreshList$ = this._refreshList$.asObservable();

  /** Gọi hàm này khi muốn chọn một hội thoại */
  public emitSelect(conversationId: string, pageId: string, channel: number, snapshot?: IConversation): void {
    this._selectConversation$.next({conversationId, pageId, channel, snapshot});
  }

  /** Gọi hàm này khi muốn thông báo hội thoại đã được đọc */
  public emitRead(conversationId: string): void {
    this._conversationRead$.next(conversationId);
  }

  /** Gọi hàm này khi muốn yêu cầu danh sách tải lại */
  public emitRefresh(): void {
    this._refreshList$.next();
  }

  // ----------------------------------------------------------------
  // 3.B.6: Mở dialog Chia sẻ hội thoại / Gán nhân viên
  // (Dialog thực tế sẽ subscribe trong Phase 4 — hiện chỉ khai báo stream)
  // ----------------------------------------------------------------

  private _openShare$ = new Subject<{ conversationId: string; snapshot?: IConversation }>();
  /** Phát đi tín hiệu yêu cầu mở dialog chia sẻ hội thoại */
  public openShare$ = this._openShare$.asObservable();

  private _openAssignStaff$ = new Subject<{ conversationId: string; snapshot?: IConversation }>();
  /** Phát đi tín hiệu yêu cầu mở dialog gán nhân viên */
  public openAssignStaff$ = this._openAssignStaff$.asObservable();

  public emitOpenShare(conversationId: string, snapshot?: IConversation): void {
    this._openShare$.next({conversationId, snapshot});
  }

  public emitOpenAssignStaff(conversationId: string, snapshot?: IConversation): void {
    this._openAssignStaff$.next({conversationId, snapshot});
  }

  // ----------------------------------------------------------------
  // 3.B.7: Mở dialog Tạo lịch hẹn (từ sidebar context menu)
  // ----------------------------------------------------------------

  private _openCreateReminder$ = new Subject<{
    conversationId: string;
    pageId: string;
    businessId: string | number | null
  }>();
  /** Phát đi tín hiệu yêu cầu mở dialog tạo lịch hẹn */
  public openCreateReminder$ = this._openCreateReminder$.asObservable();

  public emitOpenCreateReminder(conversationId: string, pageId: string, businessId: string | number | null): void {
    this._openCreateReminder$.next({conversationId, pageId, businessId});
  }

  // ----------------------------------------------------------------
  // Generic Event Bus — cho các sự kiện realtime từ ConversationListService
  // (friendRequest, postItem, businessQuickMessageChanged, v.v.)
  // ----------------------------------------------------------------

  private _eventBus$ = new Subject<{ type: string; data: unknown }>();
  public eventBus$ = this._eventBus$.asObservable();

  public emitEvent(type: string, data: unknown): void {
    this._eventBus$.next({type, data});
  }
}
